let websocket = null
let reconnectToken = null
let lastSocketStatus = null
let lastSourceUpdate = null

function getWsUrl() {
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
  return `${protocol}://${window.location.host}`
}

function connectWebSocket(token) {
  if (!token) {
    console.error('No access token available. Please log in first.')
    return
  }

  if (websocket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(websocket.readyState)) {
    return
  }

  reconnectToken = token

  const wsUrl = `${getWsUrl()}?token=${token}`

  websocket = new WebSocket(wsUrl)
  window.websocket = websocket

  websocket.onopen = () => {
    console.log('WebSocket connection established.')
    window.dispatchEvent(new Event('ws:open'))
  }

  websocket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data)
      console.log('Received data from backend:', data)
      window.dispatchEvent(new MessageEvent('ws:message', { data: event.data }))

      if (data.type === 'SOURCE_UPDATED') {
        lastSourceUpdate = data
        window.dispatchEvent(new CustomEvent('ws:source-updated', { detail: data }))
      }

      if (data.type === 'SOCKET_STATUS') {
        lastSocketStatus = data
        window.dispatchEvent(new CustomEvent('ws:status', { detail: data }))
      }
    } catch (e) {
      console.error('Error parsing received message:', event.data, e)
    }
  }

  // Connection closed (planned or due to error/rejection)
  websocket.onclose = (event) => {
    console.log(`WebSocket connection closed. Code: ${event.code}, Reason: ${event.reason}`)
    window.dispatchEvent(new Event('ws:close'))

    if (event.code === 1008) {
      console.error('Connection rejected due to invalid or expired token. Please re-authenticate.')
    }

    // Optionally attempt to reconnect after a delay
    if (event.code !== 1000 && event.code !== 1008) {
      console.log('Attempting to reconnect in 5 seconds...')
      setTimeout(() => connectWebSocket(reconnectToken), 5000)
    }
  }

  // Connection error
  websocket.onerror = (error) => {
    console.error('WebSocket Error:', error)
    window.dispatchEvent(new Event('ws:error'))
  }
}

function closeWebSocket() {
  reconnectToken = null
  lastSocketStatus = null
  lastSourceUpdate = null

  if (websocket) {
    websocket.close()
  }

  websocket = null
  window.websocket = null
}

function getWebSocketSnapshot() {
  return {
    socketStatus: lastSocketStatus,
    sourceUpdate: lastSourceUpdate,
  }
}

export { connectWebSocket, closeWebSocket, getWebSocketSnapshot }
